import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { motion } from "framer-motion";

// Animation variants 
const getLeftServiceCardVariant = (i) => {
  return {
    hidden: { opacity: 0/*, x: -100 - (i * 10) */}, // Start from the left
    visible: {
      opacity: 1,
    //   x: 0,
      transition: { duration: 0.5, delay: i * 0.1 } // Add a slight delay based on the card index
    }
  };
}


// Animation variants 
const getRightServiceCardVariant = (i) => {
  return {
    hidden: { opacity: 0/*, x: 100 + (i * 10)*/ }, // Start from the right
    visible: {
      opacity: 1,
    //   x: 0,
      transition: { duration: 0.5, delay: i * 0.1 } // Add a slight delay based on the card index
    }
  };
}

const onClick = (p) => (e) => {
  e.preventDefault();
  window.location.href = p;
}

const WhatWeDo = () => {
    return (
      <section className="work-section services-section">
        <div className="inner">
          <div className="col">
          {/* <h1 className="impact-hdr">Services</h1> */}
            <h1 className="impact-hdr">Explore our services</h1>
            {/* <p>We offer a wide range of services in software solutions including hosting.</p> */}
          </div>
          <div className="services-container services-section-cards">
          {/* <motion.div
            initial="hidden"
            variants={getLeftServiceCardVariant(0)}
            whileInView={"visible"} className="service-card wide">
              <div className="inner">
                <div className="image">
                  <LazyLoadImage effect="blur" src="/images/custom_web_devimg.jpg" placeholderSrc="/images/custom_web_devimg_sm.jpeg" />
                </div>
                <div className="overlay">
                  <button onClick={onClick("/services/custom_website")} className="text-button black impact-hdr">CUSTOM WEB DEVELOPMENT &rarr;</button>
                  <p>Learn More</p>
                </div>
              </div>
            </motion.div> */}
            <motion.div
            initial="hidden"
            variants={getLeftServiceCardVariant(0)}
            whileInView={"visible"} className="service-card wide">
              <div className="inner">
                <div className="image">
                  <LazyLoadImage effect="blur" src="/images/custom_web_devimg.jpg" placeholderSrc="/images/custom_web_devimg_sm.jpeg" />
                </div>
                <div className="overlay">
                  <button onClick={onClick("/services/ai")} className="text-button black impact-hdr">AI/ML Solutions &rarr;</button>
                  <p>Learn More</p>
                </div>
              </div>
            </motion.div>
            <motion.div
            initial="hidden"
            variants={getRightServiceCardVariant(0)}
            whileInView={"visible"} className="service-card small">
              <div className="inner">
                <div className="image">
                <LazyLoadImage effect="blur" src="/images/web_design_img.jpg" placeholderSrc="/images/web_design_img_sm.jpeg" />
                  {/* <img src="https://s7ap1.scene7.com/is/image/TCSCOMprod/worldwide-hub-hero-banner-Web?wid=3500&hei=1379&dpr=off" /> */}
                </div>
                <div className="overlay">
                  <button onClick={onClick("/services/custom_website")} className="text-button black impact-hdr">WEB DEVELOPMENT &rarr;</button>
                  <p>Learn More</p>
                </div>
              </div>
            </motion.div>
            <motion.div
            initial="hidden"
            variants={getLeftServiceCardVariant(0)}
            whileInView={"visible"} className="service-card med -st">
              <div className="inner">
                <div className="image">
                <LazyLoadImage effect="blur" src="/images/mobile_app_dev.jpg" placeholderSrc="/images/mobile_app_dev_sm.jpeg" />
                </div>
                <div className="overlay">
                  <button onClick={onClick("/services/mobile_development")} className="text-button black impact-hdr">MOBILE APP DEVELOPMENT &rarr;</button>
                  <p>Learn More</p>
                </div>
              </div>
            </motion.div>
            <motion.div
            initial="hidden"
            variants={getRightServiceCardVariant(0)}
            whileInView={"visible"} className="service-card med">
              <div className="inner">
                <div className="image">
                <LazyLoadImage effect="blur" src="/images/desktop_app_3.jpg" placeholderSrc="/images/desktop_app_3_sm.jpeg" />
                </div>
                <div className="overlay">
                  <button onClick={onClick("/services/desktop_development")} className="text-button black impact-hdr">DESKTOP APP DEVELOPMENT &rarr;</button>
                  <p>Learn More</p>
                </div>
              </div>
            </motion.div>
            <motion.div
            initial="hidden"
            variants={getLeftServiceCardVariant(0)}
            whileInView={"visible"} className="service-card small">
              <div className="inner">
                <div className="image">
                <LazyLoadImage effect="blur" src="/images/domains_pic.jpg" placeholderSrc="/images/domains_pic_sm.jpeg" />
                </div>
                <div className="overlay">
                  <button onClick={onClick("/solutions/domains")} className="text-button black impact-hdr">DOMAINS &rarr;</button>
                  <p>Learn More</p>
                </div>
              </div>
            </motion.div>
            <motion.div
            initial="hidden"
            variants={getRightServiceCardVariant(0)}
            whileInView={"visible"} className="service-card wide">
              <div className="inner">
                <div className="image">
                <LazyLoadImage effect="blur" src="/images/hosting-img.jpg" placeholderSrc="/images/hosting-img_sm.jpeg" />
                </div>
                <div className="overlay">
                  <button onClick={onClick("/solutions/hosting")} className="text-button black impact-hdr">HOSTING SOLUTION &rarr;</button>
                  <p>Learn More</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    );
  }

  export default WhatWeDo;